/**
 * Mã lỗi sao chép dữ liệu
 */
export default {
  Success: 0,
  LimitedCode: 1,
  GenNewCode: 2,
  GenNewSecondCode: 3,
  GenNewThirdCode: 4,
  NoData: 5,
  NoDataToPost: 6,
  Exception: 7
};
